import { MODE_TRACKS, poisFor } from '../lib/trackModes';
import { WP_KINDS } from '../lib/track';
import { poiHtml } from './trackLayer';

// legend in leisure mode: only tour lines, waypoints and leisure symbols
export default function LeisureLegend({ t, project }) {
  // symbols of the activities that were recorded in this project (fallback: hiking)
  const acts = [...new Set((project?.tracks || []).map((x) => x.profile).filter((p) => p in MODE_TRACKS.outdoor))];
  const pois = [...new Set((acts.length ? acts : ['hike']).flatMap(poisFor))];
  return (
    <>
      <b data-testid="legend-tours-title">{t.legTours}</b>
      {Object.entries(MODE_TRACKS.outdoor).map(([k, p]) => <div key={k} className="lg-row" data-testid={`legend-tour-${k}`}><i className="lg-line" style={{ background: p.color }} />{p.icon} {t['trkP_' + k]}</div>)}
      <b data-testid="legend-poi-title">{t.legPoi}</b>
      <div className="lg-row"><i className="lg-dot" style={{ background: WP_KINDS.note.color }} />{t.wpK_note}</div>
      {pois.map((k) => <div key={k} className="lg-row" data-testid={`legend-poi-${k}`}><span dangerouslySetInnerHTML={{ __html: poiHtml(k) }} />{String(t['poi_' + k] || '').replace(/^\S+\s/u, '')}</div>)}
    </>
  );
}
